module.exports = __webpack_public_path__ + "static/img/enterpriseBig1.14f73805.png";